import { Link } from "react-router-dom";

const stats: { value: string; label: string }[] = [
  { value: "1200+", label: "收录影视条目" },
  { value: "8.6", label: "《出轨的妻子》评分" },
  { value: "5", label: "核心内容板块" },
];

export default function SiteIntro() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-8 md:py-16" aria-label="网站简介">
      <div className="grid grid-cols-1 gap-8 rounded-lg border border-background-200 bg-background-50 p-6 md:grid-cols-2 md:gap-12 md:p-12">
        <div>
          <p className="font-label text-sm font-medium text-accent-600">关于本站</p>
          <h2 className="mt-1.5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
            为影迷打造的高清影视资源与剧情介绍站
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            《出轨的妻子》hd 以电影《出轨的妻子》为核心，为影迷提供高清影视资源信息、完整剧情介绍、精选影评与观看指南。
            我们希望用清晰的分类、便捷的筛选与真诚的文字，帮助每一位用户快速找到想看的内容，读懂每一部电影背后的情绪。
          </p>
          <div className="mt-6 grid grid-cols-3 gap-4">
            {stats.map((item) => (
              <div key={item.label} className="rounded-lg bg-secondary-50 p-3 md:p-4">
                <p className="font-heading text-xl font-bold text-primary-600 md:text-2xl">
                  {item.value}
                </p>
                <p className="mt-1 text-xs leading-snug text-foreground-500">{item.label}</p>
              </div>
            ))}
          </div>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link
              to="/category"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-film-line" aria-hidden="true"></i>
              浏览电影分类
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 font-label text-sm text-foreground-700 transition-colors hover:border-accent-300 hover:text-accent-700 cursor-pointer"
            >
              了解我们
            </Link>
          </div>
        </div>

        <div className="relative w-full overflow-hidden rounded-lg bg-background-100">
          <img
            src="https://readdy.ai/api/search-image?query=Stylish%20dark%20home%20cinema%20interior%20with%20a%20large%20glowing%20screen%2C%20cozy%20seating%20and%20warm%20amber%20accent%20lights%20against%20deep%20blue%20walls%2C%20cinematic%20cozy%20atmosphere%2C%20photorealistic%20interior%20photography&width=1000&height=800&seq=intro-cinema-01&orientation=landscape"
            alt="影视资源展示与剧情介绍"
            title="影视资源展示与剧情介绍"
            className="h-full min-h-[280px] w-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}